import React, { useMemo, useState } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import Text from '../../../../../components/Text';
import StyleInput from '../../../../../components/StyleInput';
import { AddIcon, DeleteIcon } from '../../../../../components/Icon';
import Dialog from '../../../../../components/Dialog';
import AutoCompleteSelect from '../../../../DutyAssign/components/AutoCompleteSelect';
import RedStar from '../../../../../components/RedStar';
import useGetAdsList from '../../../../../utils/hooks/list/useGetAdsList';
import { getUUID } from '../../../../../utils';
import { AutoCompleteInput } from '../../../../../components';
import RecipientsListPopup from './RecipientsListPopup';

const useStyles = makeStyles(() => ({
  deleteIcon: {
    fontSize: '1.5rem',
    color: '#538FFF',
  },
  addIcon: {
    fontSize: '1.125rem',
    color: '#538FFF',
  },
  checkBox: {
    marginRight: '0',
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
  reminder: {
    fontSize: '1rem',
    color: '#ff0300',
    fontWeight: '500',
    marginLeft: '0.5rem',
  },
}));

const SatelliteStorePopup = ({
  data,
  thresholdSettingsReadOnly,
  handleClose,
  handleUpdate,
  wardsOptions,
  boundDeviceWards = [],
}) => {
  const classes = useStyles();
  const [recipientsListPopup, setRecipientsListPopup] = useState(false);
  const [formData, setFormData] = useState(initFormData(data));
  const [adsItemList] = useGetAdsList();

  const handleAddSatelliteStore = () => {
    setFormData((prevState) => ({
      ...prevState,
      satelliteStores: [
        ...prevState.satelliteStores,
        {
          adsLocation: '',
          categorySatelliteStoresId: 0,
          satelliteStoresName: '',
          thresholdSettingsDay: 1,
          wardId: '',
          satelliteStoresAlertThreshold: 0,
          id: getUUID(),
        },
      ],
    }));
  };

  const handleDeleteSatelliteStore = (id, wardId) => {
    // 已有设备的ward是最后一个时不允许删除
    setFormData((prevState) => {
      const isBoundDeviceWard = boundDeviceWards.some((item) => item.id === wardId);
      const isLastBoundDeviceWard =
        isBoundDeviceWard && _.filter(prevState.satelliteStores, (item) => item.wardId === wardId).length === 1;

      if (isLastBoundDeviceWard) {
        return {
          ...prevState,
          satelliteStores: prevState.satelliteStores.map((item) =>
            item.id === id ? { ...item, satelliteStoresName: '', adsLocation: '' } : item
          ),
        }; // 不允许删除
      } else {
        return {
          ...prevState,
          satelliteStores: prevState.satelliteStores.filter((item) => item.id !== id),
        };
      }
    });
  };

  const handleChange = (key, id) => (value) => {
    let tempValue = value;
    if (key === 'thresholdSettingsDay' && Number(tempValue) < 1) {
      tempValue = '1';
    }
    setFormData((prevState) => ({
      ...prevState,
      satelliteStores: prevState.satelliteStores.map((item) => (item.id === id ? { ...item, [key]: tempValue } : item)),
    }));
  };

  const handleSubmit = () => {
    handleUpdate(formData.satelliteStores);
    handleClose();
  };

  const disabledUpdate = useMemo(() => {
    return formData.satelliteStores.some((item) => !item.wardId || !item.satelliteStoresName);
  }, [formData.satelliteStores]);

  return (
    <>
      <Dialog
        open={true}
        title={
          <Text fontSize="1.5rem" fontWeight="bold" color="#2e4469">
            Satellite Store List
            {boundDeviceWards?.length > 0 && (
              <span className={classes.reminder}>
                Ward {boundDeviceWards.map((item) => item.name).join(', ')} has been attached with equipment and cannot
                be cancelled.
              </span>
            )}
          </Text>
        }
        cancel="Cancel"
        confirm="Confirm"
        dialogfootStyle={{ marginTop: '0', paddingTop: '1rem', borderTop: '1px solid #E6E9F2' }}
        width="auto"
        handleClose={handleClose}
        handleCancel={handleClose}
        handleConfirm={handleSubmit}
        disabled={disabledUpdate}
      >
        <Box display="flex" flexDirection="column" mb="2.5rem">
          {/* TODO: 后续再做这部分 */}
          {/* <Box
            display="flex"
            justifyContent="space-between"
            bgcolor="#F5FAFF"
            borderRadius="0.625rem"
            p="0.25rem 1.25rem"
            mb="1.87rem"
          >
            <FormControlLabel
              id="setting_add_equipment_checkbox2"
              control={<Checkbox />}
              label="Email Alert for Low stock warning"
              className={classes.checkBox}
              // checked={Boolean(formData.isReceiptConfirmation)}
              // onChange={checkChange('isReceiptConfirmation')}
            />
            <ButtonBase onClick={() => setRecipientsListPopup(true)}>
              <Text fontSize="1rem" color="#538FFF">
                Edit List (4)
              </Text>
              <DropRightIcon style={{ fontSize: '0.625rem', color: '#538FFF', marginLeft: '1rem' }} />
            </ButtonBase>
          </Box> */}
          <Box display="flex" gridGap="0.63rem" mb="0.62rem">
            <Box width="13.56rem">
              <Text fontSize="1rem" color="#2E4469">
                Central Store
                <RedStar />
              </Text>
            </Box>
            <Box width="13.56rem">
              <Text fontSize="1rem" color="#2E4469">
                Satellite Store
                <RedStar />
              </Text>
            </Box>
            <Box width="13.56rem">
              <Text fontSize="1rem" color="#2E4469">
                ADS location
              </Text>
            </Box>
            <Box width="13.56rem">
              <Text fontSize="1rem" color="#2E4469">
                Device count for Urgent Returning ADS Order
              </Text>
            </Box>
            <Box width="2.25rem" />
          </Box>
          {formData?.satelliteStores?.map?.((item) => (
            <Box display="flex" gridGap="0.63rem" mb="0.62rem" key={item.id}>
              <Box width="13.56rem">
                <AutoCompleteInput
                  placeholder="Text here"
                  itemList={wardsOptions}
                  value={item.wardId}
                  onChange={handleChange('wardId', item.id)}
                />
              </Box>
              <Box width="13.56rem">
                <Text fontSize="1rem" color="#2E4469">
                  <StyleInput
                    placeholder="Text here"
                    value={item.satelliteStoresName}
                    onChange={handleChange('satelliteStoresName', item.id)}
                    inputProps={{ maxLength: 10 }}
                  />
                </Text>
              </Box>
              <Box width="13.56rem">
                <Text fontSize="1rem" color="#2E4469">
                  <AutoCompleteSelect
                    placeholder="(Optional)"
                    itemList={adsItemList}
                    value={item.adsLocation}
                    onChange={handleChange('adsLocation', item.id)}
                  />
                </Text>
              </Box>
              <Box width="13.56rem">
                <Text fontSize="1rem" color="#2E4469">
                  <StyleInput
                    placeholder="(Optional)"
                    value={item.thresholdSettingsDay}
                    onChange={handleChange('thresholdSettingsDay', item.id)}
                    disabled={thresholdSettingsReadOnly}
                    inputProps={{ type: 'number' }}
                  />
                </Text>
              </Box>
              <Box display="flex" alignItems="center" width="2.25rem">
                {!item.satelliteBoundDevice && (
                  <ButtonBase onClick={() => handleDeleteSatelliteStore(item.id, item.wardId)}>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      width="2.25rem"
                      height="2.25rem"
                      borderRadius="0.5rem"
                      border="1px solid #538FFF"
                      bgcolor="#F5FAFF"
                    >
                      <DeleteIcon className={classes.deleteIcon} />
                    </Box>
                  </ButtonBase>
                )}
              </Box>
            </Box>
          ))}
          <Box>
            <ButtonBase onClick={handleAddSatelliteStore}>
              <AddIcon className={classes.addIcon} />
              <Text ml="0.69rem" fontSize="1rem" color="#538FFF" fontWeight="700">
                Add more satellite stores
              </Text>
            </ButtonBase>
          </Box>
        </Box>
      </Dialog>
      {recipientsListPopup && <RecipientsListPopup handleClose={() => setRecipientsListPopup(false)} />}
    </>
  );
};

const initFormData = (data) => () => {
  return {
    satelliteStores:
      data?.satelliteStores?.length > 0
        ? data?.satelliteStores?.map?.((item) => ({
            adsLocation: item.adsLocation,
            categorySatelliteStoresId: item.categorySatelliteStoresId,
            satelliteStoresName: item.satelliteStoresName,
            thresholdSettingsDay: item.thresholdSettingsDay,
            wardId: item.wardId,
            satelliteBoundDevice: Boolean(item.satelliteBoundDevice),
            satelliteStoresAlertThreshold: item?.satelliteStoresAlertThreshold,
            id: getUUID(),
          }))
        : [
            {
              adsLocation: '',
              categorySatelliteStoresId: 0,
              satelliteStoresName: '',
              thresholdSettingsDay: 1,
              wardId: '',
              satelliteBoundDevice: false,
              satelliteStoresAlertThreshold: 0,
              id: getUUID(),
            },
          ],
  };
};

export default SatelliteStorePopup;
